import { render } from "./FeedbackConversation.vue?vue&type=template&id=1320d719"
import script from "./FeedbackConversation.vue?vue&type=script&lang=js"
export * from "./FeedbackConversation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__